import { MetricsQueryParams } from '@/api/Metrics/Types/MetricsDto'
import { CurrencyType } from '@/api/Wallet/Types/Wallet'
import { TData, TMetricsCategory } from '@/components/Metrics/helpers/processChartData'
import { WidgetType } from '@/routes/Dashboard/types'
import { MetricsApiClient } from '@/utils/api/metricsApi'

export const NV_METRICS_CATEGORY = 'nvMetrics'
export const LOTS_METRICS_CATEGORY = 'lotsMetrics'
export const FTD_METRICS_CATEGORY = 'ftdMetrics'
export const DEPOSITS_METRICS_CATEGORY = 'depositsMetrics'
export const NET_DEPOSITS_METRICS_CATEGORY = 'netDepositsMetrics'
export const NEW_CLIENTS_METRICS_CATEGORY = 'newClientsMetrics'
export const ACTIVE_CLIENTS_METRICS_CATEGORY = 'activeClientsMetrics'
export const OPENED_TA_METRICS_CATEGORY = 'openedTAMetrics'
export const ACTIVE_TA_METRICS_CATEGORY = 'activeTAMetrics'
export const IB_COMMISSIONS_METRICS_CATEGORY = 'ibCommissionsMetrics'

export interface MetricsWidgetConfig {
  title: string
  category: TMetricsCategory
  unit?: CurrencyType
  fetchData: (client: MetricsApiClient, params: MetricsQueryParams) => Promise<TData>
}

export const WIDGET_CONFIG: Partial<Record<WidgetType, MetricsWidgetConfig>> = {
  [WidgetType.NV_TRADED]: {
    title: 'NV',
    category: NV_METRICS_CATEGORY,
    unit: 'USD',
    fetchData: (client, params) => client.getNVMetrics(params),
  },
  [WidgetType.LOTS_TRADED]: {
    title: 'Lots',
    category: LOTS_METRICS_CATEGORY,
    fetchData: (client, params) => client.getLotsMetrics(params),
  },
  [WidgetType.FIRST_TIME_DEPOSIT]: {
    title: 'FTDs',
    category: FTD_METRICS_CATEGORY,
    fetchData: (client, params) => client.getFTDMetrics(params),
  },
  [WidgetType.DEPOSITS]: {
    title: 'Deposits',
    category: DEPOSITS_METRICS_CATEGORY,
    unit: 'USD',
    fetchData: (client, params) => client.getDepositsMetrics(params),
  },
  [WidgetType.NET_DEPOSITS]: {
    title: 'Net deposits',
    category: NET_DEPOSITS_METRICS_CATEGORY,
    unit: 'USD',
    fetchData: (client, params) => client.getNetDepositsMetrics(params),
  },
  [WidgetType.NEW_CLIENTS]: {
    title: 'New clients',
    category: NEW_CLIENTS_METRICS_CATEGORY,
    fetchData: (client, params) => client.getNewClientsMetrics(params),
  },
  [WidgetType.OPENED_TA]: {
    title: 'TAs opened',
    category: OPENED_TA_METRICS_CATEGORY,
    fetchData: (client, params) => client.getOpenedTAMetrics(params),
  },
  [WidgetType.IB_COMMISSIONS]: {
    title: 'IB commissions paid',
    category: IB_COMMISSIONS_METRICS_CATEGORY,
    unit: 'USD',
    fetchData: (client, params) => client.getIBCommissionsMetrics(params),
  },
}

export type ChartWidgetType = keyof typeof WIDGET_CONFIG

export const CJM_WIDGET_TITLE_KEYS = {
  linkClicked: 'Link Clicked',
  emailVerified: 'Email Verified',
  activated: 'Activated',
  deposited: 'Deposited',
  traded: 'Traded',
  activeTrading: 'Active Trading',
}
